import { render, staticRenderFns } from "./DiagnosisPicker.vue?vue&type=template&id=28bd4c20&"
import script from "./DiagnosisPicker.vue?vue&type=script&lang=js&"
export * from "./DiagnosisPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCombobox,VListItemContent})
